import { LayoutType } from 'signup-components/types';
export const isLeftAlignedLayout = layoutType => {
  return [LayoutType.LeftAligned, LayoutType.LeftAlignedTwoColumn].includes(layoutType);
};